import * as React from 'react';
import { Row, Col, Button, Modal, Form, Table, FormControl, Card } from 'react-bootstrap';
import { RouteComponentProps, Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import {
    STORE_USERS, STORE_COMMON
} from '../../constants';
import { UsersStore, CommonStore, UserInfo } from '../../stores';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkContainer } from 'react-router-bootstrap';
import { wrapCheckbox, wrapInput } from '../../common/FormChangeWrapper';

interface IProps {
    [STORE_USERS]: UsersStore,
    [STORE_COMMON]: CommonStore
}

interface IState {
    userId: string;
    userFio: string;
    roles: string[];
    isNewUser: boolean;
}

type Props = IProps
    & RouteComponentProps<{ userId?: string }>



@inject(STORE_USERS, STORE_COMMON)
@observer
export default class EditRolesPage extends React.Component<Props, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            userId: this.props.match.params.userId || "",
            userFio: '',
            roles: [],
            isNewUser: this.props.match.params.userId === undefined
        };
    }

    usersStore = this.props[STORE_USERS];
    commonStore = this.props[STORE_COMMON];


    componentDidMount() {
        document.title = `${this.commonStore.currentPageName} - ${this.commonStore.appName}`;
        this.commonStore.setPageName(`Редактирование ролей для пользователя`);
        this.loadData();
    }

    private loadData = () => {
        let currentUser: UserInfo[];
        if (this.usersStore.users == undefined || this.usersStore.users.length <= 0) {
            this.usersStore.loadUsers(() => {
                currentUser = this.usersStore.users.filter(w => w.userId == this.state.userId);

                if (currentUser == null || currentUser.length < 1)
                    this.commonStore.notifyError("Пользователь не найден!");
                else {
                    this.setState({
                        userFio: currentUser[0].userFio,
                        roles: currentUser[0].roles
                    });
                }
            });
        }
        else {
            currentUser = this.usersStore.users.filter(w => w.userId == this.state.userId);

            if (currentUser == null || currentUser.length < 1)
                this.commonStore.notifyError("Пользователь не найден!");
            else {
                this.setState({
                    userFio: currentUser[0].userFio,
                    roles: currentUser[0].roles
                });
            }
        }
    }
    private saveHandler = () => {
        // if (!this.isEmail(this.state.email)) {
        //     this.commonStore.notifyError("Email не соответствует формату!");
        //     return;
        // }
        this.usersStore.saveRoles(this.state.userId, this.state.roles, () => {
            this.props.history.push("/roles/users")
        });
    }

    private handleCheckbox = (fieldName: string, value: string, checked: boolean) => {
        if (checked) {
            if (this.state.roles.indexOf(value) <= -1) {
                this.setState({
                    roles: [...this.state.roles, value]
                })
            }
        }
        else
            this.setState({
                roles: this.state.roles.filter(w => w != value)
            })
    }

    // public emailChangeHandler = (fieldName: string, value: string) => {
    //     this.setState({ email: value });
    // }

    private isEmail = (value: string) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value);
    }

    render() {
        return <div>
            <Row>
                <Col sm={8}>
                    <h1>
                        {this.commonStore.currentPageName}
                    </h1>
                </Col>
                <Col sm={4} className="text-right">
                    <Button size="sm" onClick={this.saveHandler}><FontAwesomeIcon icon="save" /> Сохранить</Button>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>

                    <br />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Table bordered striped className="table-xxs" >
                        <thead>
                            <tr>
                                <th className="text-center">Пользователь</th>
                                <th>Права доступа</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowSpan={9} className="text-center">
                                    {this.state.userFio}
                                </td>
                                <td>
                                    <Form.Check type="checkbox"
                                        name="WebClient"
                                        label="Общий доступ на просмотр данных"
                                        value="WebClient"
                                        checked={this.state.roles.indexOf("WebClient") > -1}
                                        onChange={wrapCheckbox(this.handleCheckbox)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Form.Check type="checkbox"
                                        name="UserManagement"
                                        label="Управление пользователями"
                                        value="UserManagement"
                                        checked={this.state.roles.indexOf("UserManagement") > -1}
                                        onChange={wrapCheckbox(this.handleCheckbox)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Form.Check type="checkbox"
                                        name="Reports"
                                        label="Доступ к отчетам"
                                        value="Reports"
                                        checked={this.state.roles.indexOf("Reports") > -1}
                                        onChange={wrapCheckbox(this.handleCheckbox)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Form.Check type="checkbox"
                                        name="KassesManager"
                                        label='Доступ к кассам'
                                        value="KassesManager"
                                        checked={this.state.roles.indexOf("KassesManager") > -1}
                                        onChange={wrapCheckbox(this.handleCheckbox)} />
                                </td>
                            </tr><tr>
                                <td>
                                    <Form.Check type="checkbox"
                                        name="AsToAbtekaManager"
                                        label='Доступ к привязке AS61'
                                        value="AsToAbtekaManager"
                                        checked={this.state.roles.indexOf("AsToAbtekaManager") > -1}
                                        onChange={wrapCheckbox(this.handleCheckbox)} />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    }

}